<template>

  <div class="consecutive-challenge-container">

    <!-- 顶部导航栏 -->

    <div class="challenge-header">

      <div class="header-left">

        <i class="el-icon-arrow-left back-btn" @click="goBack"></i>

        <h1 class="page-title">连对挑战</h1>

      </div>

      <div class="header-right">

        <div class="timer-display" :style="{ marginRight: '20px', fontWeight: 'bold', color: timerColor }" v-if="currentQuestion">

          <i class="el-icon-time"></i> {{ currentQuestionTime }}

        </div>

        <el-radio-group v-model="language" size="small" style="margin-right:10px;" v-if="currentQuestion">

          <el-radio-button label="cn">中文</el-radio-button>

          <el-radio-button label="en">English</el-radio-button>

          <el-radio-button label="both">双语</el-radio-button>

        </el-radio-group>

        <el-button

          type="danger"

          size="small"

          icon="el-icon-close"

          @click="endChallenge"

          v-if="isChallengeActive">

          结束挑战

        </el-button>

      </div>

    </div>



    <!-- 加载状态 -->

    <div v-if="loading" class="loading-container">

      <el-loading

        :loading="loading"

        text="正在加载挑战题目..."

        background="rgba(0, 0, 0, 0.8)"

      />

    </div>



    <!-- 错误状态 -->

    <div v-else-if="error" class="error-container">

      <div class="error-content">

        <i class="el-icon-warning error-icon"></i>

        <p class="error-message">{{ error }}</p>

        <el-button type="primary" @click="refreshChallenge">重新加载</el-button>

      </div>

    </div>



    <!-- 过渡界面 -->

    <div v-else-if="showLanding" class="landing-container">

      <div class="landing-hero">

        <div class="landing-icon">🔥</div>

        <h2 class="landing-title">连对挑战</h2>

        <p class="landing-desc">挑战连续答对10题！<br>答错即结束挑战</p>

      </div>



      <div class="landing-rules">

        <div class="rule-tag"><i class="el-icon-refresh"></i> 无限次</div>

        <div class="rule-tag rule-tag-danger"><i class="el-icon-circle-close"></i> 答错即结束</div>

        <div class="rule-tag rule-tag-warn"><i class="el-icon-time"></i> 每题限时90s</div>

      </div>



      <div class="landing-best" v-if="best7Days && best7Days.consecutiveCount > 0">

        <i class="el-icon-trophy"></i> 7日最佳：连对 <strong>{{ best7Days.consecutiveCount }}</strong> 题，用时 <strong>{{ formatSeconds(best7Days.totalTimeSeconds) }}</strong>

      </div>

      <div class="landing-best" v-else-if="bestRecord > 0">

        <i class="el-icon-trophy"></i> 历史最佳：连对 <strong>{{ bestRecord }}</strong> 题

      </div>



      <div class="landing-start">

        <button class="start-challenge-btn" @click="beginChallenge">开始挑战</button>

      </div>



      <div class="landing-start" style="margin-top: -20px;">

        <button class="leaderboard-btn" @click="openLeaderboard"><i class="el-icon-s-data"></i> 排行榜</button>

      </div>



      <div class="landing-stats-card">

        <div class="landing-record-columns">

          <div class="landing-record-column">

            <div class="landing-record-title">7日</div>

            <div v-if="challengeRecords.week.length" class="landing-record-list">

              <div

                v-for="record in challengeRecords.week"

                :key="`week-${record.id}`"

                class="landing-record-item"

              >

                <div class="landing-record-main">

                  <span class="landing-record-count">连对 {{ record.consecutiveCount }} 题</span>

                  <span class="landing-record-time">{{ formatSeconds(record.totalTimeSeconds) }}</span>

                </div>

                <div class="landing-record-date">{{ formatDateTime(record.createdAt) }}</div>

              </div>

            </div>

            <div v-else class="landing-record-empty">暂无记录</div>

          </div>

          <div class="landing-record-column">

            <div class="landing-record-title">本月</div>

            <div v-if="challengeRecords.month.length" class="landing-record-list">

              <div

                v-for="record in challengeRecords.month"

                :key="`month-${record.id}`"

                class="landing-record-item"

              >

                <div class="landing-record-main">

                  <span class="landing-record-count">连对 {{ record.consecutiveCount }} 题</span>

                  <span class="landing-record-time">{{ formatSeconds(record.totalTimeSeconds) }}</span>

                </div>

                <div class="landing-record-date">{{ formatDateTime(record.createdAt) }}</div>

              </div>

            </div>

            <div v-else class="landing-record-empty">暂无记录</div>

          </div>

        </div>

      </div>

    </div>



    <!-- 挑战内容 -->

    <div v-else-if="currentQuestion" class="challenge-content">

      <!-- 挑战统计信息 -->

      <div class="stats-section">

        <div class="stat-card">

          <div class="stat-number">{{ consecutiveCount }}</div>

          <div class="stat-label">当前连对数</div>

        </div>

        <div class="stat-card">

          <div class="stat-number">{{ totalAnswered }}</div>

          <div class="stat-label">总答题数</div>

        </div>

        <div class="stat-card">

          <div class="stat-number">{{ bestRecord }}</div>

          <div class="stat-label">最佳记录</div>

        </div>

        <div class="stat-card">

          <div class="stat-number">{{ questionNumber }}</div>

          <div class="stat-label">第{{ questionNumber }}题</div>

        </div>

      </div>



      <!-- 题目卡片 -->

      <div class="question-card">

        <div class="question-header">

          <div class="question-title">

            <span class="question-number">连对挑战 - 第{{ questionNumber }}题</span>

            <span class="challenge-status" :class="getChallengeStatusClass()">

              {{ getChallengeStatusText() }}

            </span>

          </div>

          <div class="question-meta">

            <span class="question-difficulty" :class="getDifficultyClass(currentQuestion.difficulty)">

              {{ getDifficultyText(currentQuestion.difficulty) }}

            </span>

            <span class="question-knowledge" v-if="currentQuestion.knowledge">

              {{ getKnowledgeName(currentQuestion.knowledge) }}

            </span>

          </div>

        </div>



        <div class="question-content" v-html="renderWithMath(getContent(currentQuestion))"></div>



        <!-- 题目图片 -->

        <div class="question-images" v-if="getQuestionImages(currentQuestion).length">

          <img

            v-for="(imgUrl, imgIdx) in getQuestionImages(currentQuestion)"

            :key="'qimg-' + imgIdx"

            :src="imgUrl"

            class="question-img"

            @click="previewImage(imgUrl)"

          />

        </div>



        <!-- 图片上传区域 -->

        <div class="image-upload-section">

          <div class="upload-button-container">

            <el-upload

              class="image-uploader"

              :action="uploadUrl"

              :headers="uploadHeaders"

              :show-file-list="false"

              :on-success="handleImageUploadSuccess"

              :on-error="handleImageUploadError"

              :before-upload="beforeImageUpload"

              accept="image/*">

              <el-button type="primary" icon="el-icon-upload" size="small">

                上传图片

              </el-button>

            </el-upload>

            <span class="upload-tip">上传解题步骤（可选）</span>

          </div>



          <!-- 已上传的图片预览 -->

          <div v-if="uploadedImages.length > 0" class="uploaded-images">

            <div class="image-preview-title">已上传的图片：</div>

            <div class="image-list">

              <div

                v-for="(image, index) in uploadedImages"

                :key="index"

                class="image-item">

                <img :src="image.url" :alt="`上传图片${index + 1}`" />

                <div class="image-actions">

                  <el-button

                    type="text"

                    icon="el-icon-view"

                    size="mini"

                    @click="previewImage(image.url)">

                    预览

                  </el-button>

                  <el-button

                    type="text"

                    icon="el-icon-delete"

                    size="mini"

                    @click="removeImage(index)">

                    删除

                  </el-button>

                </div>

              </div>

            </div>

          </div>

        </div>



        <!-- 选项显示 -->
        <div class="question-options" v-if="parseOptions(currentQuestion.optionsStr || getOptionText(currentQuestion)).length > 0 || hasOptionImages(currentQuestion)">
          <el-radio-group v-model="userAnswer" @change="onAnswerChange">
            <el-radio
              v-for="(option, optIdx) in parseOptions(currentQuestion.optionsStr || getOptionText(currentQuestion))"
              :key="option.key"
              :label="option.key"
              class="option-item"
            >
              <template v-if="getOptionImage(currentQuestion, optIdx)">
                <div class="option-image-wrap">
                  <span class="option-key-label">{{ option.key }}.</span>
                  <img
                    :src="getMinioUrl(getOptionImage(currentQuestion, optIdx))"
                    class="option-img"
                    @click="previewImage(getMinioUrl(getOptionImage(currentQuestion, optIdx)))"
                  />
                </div>
              </template>
              <template v-else>
                <span v-html="renderWithMath(option.key + '. ' + option.value)"></span>
              </template>
            </el-radio>
          </el-radio-group>
        </div>



        <!-- 如果没有选项，显示答案输入框 -->

        <div class="question-answer-input" v-else>

          <el-input

            v-model="userAnswer"

            @input="onAnswerChange"

            placeholder="请输入答案"

            maxlength="10"

            show-word-limit

            style="width: 200px"

          ></el-input>

          <span class="answer-tip">（请输入答案，如：A、B、C、D、E 或具体数值）</span>

        </div>



        <!-- 答题状态 -->

        <div v-if="hasAnswered" class="answer-status">

          <div v-if="isAnswerCorrect()" class="correct-answer">

            <i class="el-icon-check"></i>

            <span>回答正确！继续挑战下一题</span>

          </div>

          <div v-else class="incorrect-answer">

            <i class="el-icon-close"></i>

            <span>回答错误，挑战结束</span>

          </div>

        </div>



        <!-- 显示解析（如果已答题） -->

        <div v-if="hasAnswered && (currentQuestion.analysisCn || currentQuestion.analysisEn || currentQuestion.analysis)" class="analysis-section">

          <div class="analysis-title">解析：</div>

          <div class="analysis-content" v-html="renderMathFormula(getExplanation(currentQuestion))"></div>

        </div>



        <!-- 操作按钮 -->

        <div class="action-buttons">

          <el-button

            v-if="!hasAnswered"

            type="primary"

            size="large"

            @click="submitAnswer"

            :disabled="!userAnswer"

            :loading="submitting">

            提交答案

          </el-button>

          <el-button

            v-if="hasAnswered && isAnswerCorrect()"

            type="success"

            size="large"

            @click="nextQuestion"

            :loading="loadingNext">

            下一题

          </el-button>

          <el-button

            v-if="hasAnswered && !isAnswerCorrect()"

            type="info"

            size="large"

            @click="showResult">

            查看结果

          </el-button>

        </div>

      </div>



      <!-- 挑战进度条 -->

      <div class="progress-section" v-if="isChallengeActive">

        <div class="progress-info">

          <span>挑战进度</span>

          <span>{{ consecutiveCount }}/{{ Math.max(consecutiveCount, 10) }}</span>

        </div>

        <el-progress

          :percentage="Math.min((consecutiveCount / Math.max(consecutiveCount, 10)) * 100, 100)"

          :color="getProgressColor()"

          :stroke-width="8">

        </el-progress>

      </div>

    </div>



    <!-- 空状态 -->

    <div v-else class="empty-container">

      <div class="empty-content">

        <i class="el-icon-document empty-icon"></i>

        <p class="empty-message">暂无题目数据</p>

        <el-button type="primary" @click="refreshChallenge">重新加载</el-button>

      </div>

    </div>



    <!-- 图片预览弹窗 -->

    <el-dialog

      title="图片预览"

      :visible.sync="showImagePreview"

      width="auto"

      :close-on-click-modal="true">

      <div class="image-preview-dialog">

        <img :src="previewImageUrl" alt="预览图片" class="preview-image" />

      </div>

    </el-dialog>



    <!-- 挑战结果弹窗 -->

    <el-dialog

      title="挑战结果"

      :visible.sync="showResultDialog"

      width="500px"

      :before-close="handleCloseResultDialog"

      :close-on-click-modal="false">

      <div class="result-content">

        <div class="result-icon">

          <i class="el-icon-trophy" v-if="consecutiveCount >= 5"></i>

          <i class="el-icon-medal" v-else-if="consecutiveCount >= 3"></i>

          <i class="el-icon-star-on" v-else></i>

        </div>

        <div class="result-title">{{ getResultTitle() }}</div>

        <div class="result-stats">

          <div class="result-stat-item">

            <span class="stat-label">本次连对数：</span>

            <span class="stat-value">{{ consecutiveCount }}</span>

          </div>

          <div class="result-stat-item">

            <span class="stat-label">总答题数：</span>

            <span class="stat-value">{{ totalAnswered }}</span>

          </div>

          <div class="result-stat-item">

            <span class="stat-label">总用时：</span>

            <span class="stat-value">{{ formatSeconds(challengeTotalSeconds) }}</span>

          </div>

          <div class="result-stat-item">

            <span class="stat-label">历史最佳：</span>

            <span class="stat-value">{{ bestRecord }}</span>

          </div>

          <div class="result-stat-item" v-if="consecutiveCount > bestRecord">

            <span class="stat-label">新纪录！</span>

            <span class="stat-value new-record">🎉</span>

          </div>

        </div>

        <div class="result-message">{{ getResultMessage() }}</div>

      </div>

      <span slot="footer" class="dialog-footer">

        <el-button @click="restartChallenge">重新挑战</el-button>

        <el-button type="primary" @click="backToCourse">返回首页</el-button>

      </span>

    </el-dialog>



    <!-- 排行榜弹窗 -->

    <el-dialog

      title="🏆 连对挑战排行榜"

      :visible.sync="showLeaderboard"

      width="600px"

      :close-on-click-modal="true">

      <div class="leaderboard-range-tabs">

        <el-radio-group v-model="leaderboardRange" size="small" @change="loadLeaderboard">

          <el-radio-button label="week">7日</el-radio-button>

          <el-radio-button label="month">本月</el-radio-button>

          <el-radio-button label="all">全部</el-radio-button>

        </el-radio-group>

      </div>

      <div v-loading="loadingLeaderboard">

        <el-table :data="leaderboard" stripe style="width: 100%" empty-text="暂无排行数据">

          <el-table-column label="排名" width="70" align="center">

            <template slot-scope="scope">

              <span v-if="scope.$index === 0" style="font-size:20px;">&#x1F947;</span>

              <span v-else-if="scope.$index === 1" style="font-size:20px;">&#x1F948;</span>

              <span v-else-if="scope.$index === 2" style="font-size:20px;">&#x1F949;</span>

              <span v-else>{{ scope.$index + 1 }}</span>

            </template>

          </el-table-column>

          <el-table-column label="用户" prop="displayName" min-width="120">

            <template slot-scope="scope">

              {{ scope.row.real_name || scope.row.user_name || '匿名用户' }}

            </template>

          </el-table-column>

          <el-table-column label="连对数" prop="consecutive_count" width="100" align="center">

            <template slot-scope="scope">

              <strong style="color:#ff4d4f; font-size:16px;">{{ scope.row.consecutive_count }}</strong>

            </template>

          </el-table-column>

          <el-table-column label="用时" width="120" align="center">

            <template slot-scope="scope">

              {{ formatSeconds(scope.row.total_time_seconds) }}

            </template>

          </el-table-column>

        </el-table>

      </div>

      <span slot="footer">

        <el-button @click="showLeaderboard = false">关闭</el-button>

      </span>

    </el-dialog>

  </div>

</template>



<script>

import { getOneUnattemptedQuestion } from '@/api/courseQuestion'

import { addRecord } from '@/api/userQuestionRecord'

import { userStatusAdd } from '@/api/userStatus'

import { saveChallengeRecord, getBestRecord, getLeaderboard, getChallengeRecords } from '@/api/challengeRecord'

import { judgeSolution } from '@/api/ai'

import { getProgressByDate, upsertTodayPlan, getProgressPaging, updateProgressFinished, getSchemeByUserIdAndRepoId, updateSchemeFinishedIds } from '@/api/studyPlan'

import { getTokenInfo } from '@/utils/jwtUtils'

import { listGeneralKnowledgeTree } from '@/api/knowledge'

import { getMinioUrl } from '@/utils/minio'

import katex from 'katex'

import 'katex/dist/katex.min.css'



export default {

  name: 'ConsecutiveChallenge',

  data() {

    return {

      // 是否显示过渡界面

      showLanding: true,

      // 挑战统计（7日/本月）

      challengeStats: {

        week: { consecutiveCount: 0, totalTimeSeconds: 0 },

        month: { consecutiveCount: 0, totalTimeSeconds: 0 }

      },

      challengeRecords: {

        week: [],

        month: []

      },

      // 知识点ID到名称的映射

      knowledgeMap: {},

      // 加载状态

      loading: false,

      loadingNext: false,

      // 错误信息

      error: null,

      // 当前题目

      currentQuestion: null,

      // 用户答案

      userAnswer: '',

      // 是否已答题

      hasAnswered: false,

      // 提交状态

      submitting: false,

      // 从路由参数获取的repoId

      repoId: null,



      // 挑战状态

      isChallengeActive: false,

      consecutiveCount: 0,

      totalAnswered: 0,

      questionNumber: 1,

      bestRecord: 0,

      // 语言：cn | en | both

      language: 'both',



      // 题目列表（不再使用全量拉取，保留占位）

      questionList: [],



      // 结果弹窗

      showResultDialog: false,



      // 图片上传相关

      uploadedImages: [],

      uploadedImageFile: null,

      imageFileList: [],

      showImagePreview: false,

      previewImageUrl: '',

      uploadUrl: '/api/upload/image', // 不再使用直传，仅占位

      // 统计：用于汇总 amc-status（只在挑战结束时上报一次）

      attemptedIds: [],

      statusSubmitted: false,

      // 计时器

      questionStartTime: null, // 当前题目开始时间

      questionDuration: 0, // 当前题目用时（秒）

      timerInterval: null, // 计时器间隔

      currentQuestionTime: '00:00', // 当前题目用时显示

      timerColor: '#67C23A', // 计时器颜色

      // 整场挑战计时

      challengeStartTime: null, // 挑战开始时间戳

      challengeTotalSeconds: 0, // 挑战总用时（秒）

      // 7日最佳记录

      best7Days: null, // { consecutiveCount, totalTimeSeconds }

      // 排行榜

      showLeaderboard: false,

      leaderboardRange: 'week',

      leaderboard: [],

      loadingLeaderboard: false,

      statProgressId: null

    }

  },

  computed: {

    // 动态获取上传头部信息

    uploadHeaders() {

      return {

        'Authorization': `Bearer ${this.$store.getters.token}`

      }

    }

  },

  created() {

    this.hideSidebarAndNavbar()

    this.initPage()

  },

  beforeDestroy() {

    this.showSidebarAndNavbar()

    if (this.timerInterval) clearInterval(this.timerInterval)

  },

  methods: {

    // 隐藏侧边栏和导航栏

    hideSidebarAndNavbar() {

      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })



      const sidebar = document.querySelector('.sidebar-container')

      const navbar = document.querySelector('.navbar')



      if (sidebar) {

        sidebar.style.display = 'none'

      }

      if (navbar) {

        navbar.style.display = 'none'

      }



      const appMain = document.querySelector('.app-main')

      if (appMain) {

        appMain.style.padding = '0'

        appMain.style.margin = '0'

      }

    },

    getTodayDate() {

      const d = new Date()

      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

    },

    async syncStudyProgress(questionId, isCorrect) {

      try {

        const user = getTokenInfo && getTokenInfo()

        const userId = user?.id

        const repoIdVal = Number(this.repoId) || this.repoId

        const qid = Number(questionId)

        if (!userId || !repoIdVal || !qid) return

        try {

          const schemeResp = await getSchemeByUserIdAndRepoId(userId, repoIdVal)

          const scheme = schemeResp?.data

          const schemeId = scheme ? (scheme.id ?? scheme.schemeId) : null

          if (schemeId) {

            const schemeFinished = String(scheme?.finishedId || scheme?.finished_id || '')

            const schemeSet = new Set(schemeFinished.split(/[，,;\s]+/).filter(x => x).map(Number))

            schemeSet.add(qid)

            const mergedSchemeIds = Array.from(schemeSet).filter(n => !isNaN(n) && n > 0).join(',')

            await updateSchemeFinishedIds(schemeId, mergedSchemeIds)

          }

        } catch (schemeErr) {

          console.error('更新学习方案失败:', schemeErr)

        }

        const todayStr = this.getTodayDate()

        let progressId = this.statProgressId

        if (!progressId) {

          const idRes = await getProgressByDate(userId, repoIdVal, todayStr)

          const idData = idRes?.data?.data ?? idRes?.data ?? idRes

          progressId = (typeof idData === 'number' || typeof idData === 'string') ? Number(idData) : (idData && idData.id)

        }

        if (!progressId) {

          const planRes = await upsertTodayPlan({ userId, repoId: repoIdVal, date: todayStr })

          const planData = planRes?.data?.data ?? planRes?.data ?? planRes

          progressId = planData && (planData.id || planData.ID)

        }

        this.statProgressId = progressId || this.statProgressId

        if (!progressId) return

        const page = await getProgressPaging({ pageNum: 1, pageSize: 1, userId, repoId: repoIdVal, dateFrom: todayStr, dateTo: todayStr })

        const pdata = page?.data?.data ?? page?.data ?? {}

        const records = Array.isArray(pdata.records) ? pdata.records : []

        const first = records && records.length ? records[0] : null

        if (!first) return

        const currentFinished = String(first.finished_id || first.finishedId || '')

        const finishedSet = new Set(currentFinished.split(/[，,;\s]+/).filter(x => x).map(Number))

        finishedSet.add(qid)

        const mergedFinished = Array.from(finishedSet).filter(n => !isNaN(n) && n > 0).join(',')

        let correctCount = Number(first.correct_count ?? first.correctCount ?? 0)

        let wrongCount = Number(first.wrong_count ?? first.wrongCount ?? 0)

        const reviewDone = Number(first.review_done ?? first.reviewDone ?? 0)

        if (isCorrect) {

          correctCount += 1

        } else {

          wrongCount += 1

        }

        await updateProgressFinished(progressId, mergedFinished, correctCount, wrongCount, reviewDone)

      } catch (e) {

        console.error('同步学习进度失败:', e)

      }

    },

    // 组合双语

    combineCnEn(cn, en) {

      const hasCn = cn && String(cn).trim() && String(cn).trim() !== '暂无'

      const hasEn = en && String(en).trim()

      if (hasCn && hasEn) {

        return `<div class="lang-cn">${cn}</div><div class="lang-en" style="margin-top:8px; color:#555;">${en}</div>`

      }

      if (hasCn) return String(cn)

      if (hasEn) return String(en)

      return ''

    },

    // 当前语言的题干/解析

    getContent(q) {

      if (!q) return ''

      const cn = q.contentCn || ''

      const en = q.contentEn || ''

      if (this.language === 'cn') return cn || en || ''

      if (this.language === 'en') return en || cn || ''

      return this.combineCnEn(cn, en)

    },

    getExplanation(q) {

      if (!q) return ''

      const cn = q.analysisCn || ''

      const en = q.analysisEn || ''

      if (this.language === 'cn') return cn || en || ''

      if (this.language === 'en') return en || cn || ''

      return this.combineCnEn(cn, en)

    },

    // 记录用题干（纯文本，无 HTML）

    stripHtml(html) {

      if (!html) return ''

      const tmp = document.createElement('div')

      tmp.innerHTML = String(html)

      const text = tmp.textContent || tmp.innerText || ''

      return text

    },

    getRecordContent(q) {

      if (!q) return ''

      const cn = q.contentCn || ''

      const en = q.contentEn || ''

      const combined = this.language === 'cn' ? (cn || en || '')

        : this.language === 'en' ? (en || cn || '')

        : `${cn || ''}${cn && en ? '\n' : ''}${en || ''}`

      return this.stripHtml(combined)

    },



    // 恢复侧边栏和导航栏

    showSidebarAndNavbar() {

      this.$store.dispatch('app/openSideBar', { withoutAnimation: false })



      const sidebar = document.querySelector('.sidebar-container')

      const navbar = document.querySelector('.navbar')



      if (sidebar) {

        sidebar.style.display = ''

      }

      if (navbar) {

        navbar.style.display = ''

      }



      const appMain = document.querySelector('.app-main')

      if (appMain) {

        appMain.style.padding = ''

        appMain.style.margin = ''

      }

    },



    // 初始化页面

    initPage() {

      // 从路由参数获取repoId

      this.repoId = this.$route.query.repoId



      if (!this.repoId) {

        this.$message.error('缺少题库ID参数')

        this.goBack()

        return

      }



      this.loadUserData()

    },



    // 加载用户数据

    async loadUserData() {

      try {

        // 获取当前用户ID

        const userInfo = getTokenInfo()

        const userId = userInfo ? userInfo.id : null



        if (!userId) {

          throw new Error('无法获取用户信息，请重新登录')

        }



        // 加载历史最佳记录

        this.loadBestRecord()

        this.loadRangeStats()

        this.loadRangeRecords()

        // 加载知识点树

        this.loadKnowledgeTree()

      } catch (error) {

        console.error('加载用户数据失败:', error)

        this.error = error.message || '加载用户数据失败'

      }

    },



    // 加载历史最佳记录

    loadBestRecord() {

      const bestRecord = localStorage.getItem('consecutive_challenge_best_record')

      this.bestRecord = bestRecord ? parseInt(bestRecord) : 0

    },



    // 加载知识点树并构建ID到名称的映射

    async loadKnowledgeTree() {

      try {

        const resp = await listGeneralKnowledgeTree(this.repoId)

        const tree = (resp && resp.data && resp.data.data)

          || (resp && resp.data)

          || resp

        if (Array.isArray(tree)) {

          this.knowledgeMap = this.buildKnowledgeMap(tree)

        }

      } catch (e) {

        console.warn('加载知识点树失败:', e)

      }

    },



    // 递归构建知识点ID到名称的映射

    buildKnowledgeMap(nodes) {

      const map = {}

      const traverse = (nodeList) => {

        if (!nodeList || !Array.isArray(nodeList)) return

        nodeList.forEach(node => {

          if (node.id && node.content) {

            map[node.id] = node.content

          }

          if (node.children && node.children.length > 0) {

            traverse(node.children)

          }

        })

      }

      traverse(nodes)

      return map

    },



    // 根据知识点ID获取名称

    getKnowledgeName(knowledgeId) {

      if (!knowledgeId) return ''

      if (Array.isArray(knowledgeId)) {

        return knowledgeId

          .map(item => this.getKnowledgeName(item))

          .filter(Boolean)

          .join(', ')

      }



      const raw = String(knowledgeId).trim()

      if (!raw) return ''



      const parts = raw

        .split(/[，,;；\s]+/)

        .map(item => String(item).trim())

        .filter(Boolean)



      if (parts.length === 0) return raw



      const hasNonNumericPart = parts.some(item => /[^0-9]/.test(item))

      if (hasNonNumericPart) {

        return parts.join(', ')

      }



      const names = parts.map(item => {

        const id = Number(item)

        if (isNaN(id)) return item

        return this.knowledgeMap[id] || this.knowledgeMap[String(id)] || item

      })



      return names.join(', ')

    },



    // 加载 7 日和本月最佳统计（后端）

    async loadRangeStats() {

      try {

        const [weekRes, monthRes] = await Promise.all([

          getBestRecord(this.repoId, 'week'),

          getBestRecord(this.repoId, 'month')

        ])

        const weekData = weekRes?.data?.data || weekRes?.data || null

        const monthData = monthRes?.data?.data || monthRes?.data || null



        this.challengeStats = {

          week: {

            consecutiveCount: weekData?.consecutiveCount || 0,

            totalTimeSeconds: weekData?.totalTimeSeconds || 0

          },

          month: {

            consecutiveCount: monthData?.consecutiveCount || 0,

            totalTimeSeconds: monthData?.totalTimeSeconds || 0

          }

        }



        this.best7Days = weekData && weekData.consecutiveCount > 0 ? weekData : null

      } catch (e) {

        console.warn('加载范围统计失败:', e)

        this.challengeStats = {

          week: { consecutiveCount: 0, totalTimeSeconds: 0 },

          month: { consecutiveCount: 0, totalTimeSeconds: 0 }

        }

        this.best7Days = null

      }

    },



    async loadRangeRecords() {

      try {

        const [weekRes, monthRes] = await Promise.all([

          getChallengeRecords(this.repoId, 'week'),

          getChallengeRecords(this.repoId, 'month')

        ])

        const weekData = weekRes?.data?.data || weekRes?.data || []

        const monthData = monthRes?.data?.data || monthRes?.data || []



        this.challengeRecords = {

          week: Array.isArray(weekData) ? weekData : [],

          month: Array.isArray(monthData) ? monthData : []

        }

      } catch (e) {

        console.warn('加载范围记录失败:', e)

        this.challengeRecords = {

          week: [],

          month: []

        }

      }

    },



    // 保存本次挑战结果

    async saveChallengeResult() {

      // 计算整场总用时

      if (this.challengeStartTime) {

        this.challengeTotalSeconds = Math.round((Date.now() - this.challengeStartTime) / 1000)

      }



      // localStorage 保存（兼容旧逻辑）

      try {

        const raw = localStorage.getItem('consecutive_challenge_history')

        const history = raw ? JSON.parse(raw) : []

        history.push({

          timestamp: new Date().toISOString(),

          questions: this.totalAnswered,

          consecutiveCount: this.consecutiveCount,

          totalTimeSeconds: this.challengeTotalSeconds

        })

        const cutoff = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString()

        const filtered = history.filter(h => h.timestamp >= cutoff)

        localStorage.setItem('consecutive_challenge_history', JSON.stringify(filtered))

      } catch (e) {

        console.warn('保存挑战结果失败(localStorage):', e)

      }



      // 后端保存

      try {

        await saveChallengeRecord({

          repoId: Number(this.repoId),

          consecutiveCount: this.consecutiveCount,

          totalTimeSeconds: this.challengeTotalSeconds,

          totalAnswered: this.totalAnswered

        })

        await this.loadRangeStats()

        await this.loadRangeRecords()

      } catch (e) {

        console.warn('保存挑战记录到后端失败:', e)

      }

    },



    // 打开排行榜

    async openLeaderboard() {

      this.showLeaderboard = true

      await this.loadLeaderboard()

    },



    async loadLeaderboard() {

      this.loadingLeaderboard = true

      try {

        const res = await getLeaderboard(this.repoId, 50, this.leaderboardRange)

        this.leaderboard = res?.data?.data || res?.data || []

      } catch (e) {

        console.warn('加载排行榜失败:', e)

        this.leaderboard = []

      } finally {

        this.loadingLeaderboard = false

      }

    },



    // 格式化秒数为 mm:ss 或 hh:mm:ss

    formatSeconds(seconds) {

      if (seconds == null || isNaN(seconds)) return '--'

      const s = Number(seconds)

      if (s < 0) return '--'

      const h = Math.floor(s / 3600)

      const m = Math.floor((s % 3600) / 60)

      const sec = s % 60

      if (h > 0) {

        return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`

      }

      return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`

    },



    formatDateTime(value) {

      if (!value) return '--'

      const date = new Date(value)

      if (isNaN(date.getTime())) return value

      const month = String(date.getMonth() + 1).padStart(2, '0')

      const day = String(date.getDate()).padStart(2, '0')

      const hours = String(date.getHours()).padStart(2, '0')

      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${month}-${day} ${hours}:${minutes}`

    },



    // 从过渡界面开始挑战

    beginChallenge() {

      this.showLanding = false

      this.loadQuestions()

    },



    // 加载题目数据（改为按需获取单题）

    async loadQuestions() {

      this.loading = true

      this.error = null

      try {

        this.startChallenge()

      } finally {

        this.loading = false

      }

    },



    // 开始挑战

    startChallenge() {

      this.isChallengeActive = true

      this.consecutiveCount = 0

      this.totalAnswered = 0

      this.questionNumber = 1

      this.attemptedIds = []

      this.statusSubmitted = false

      this.challengeStartTime = Date.now()

      this.challengeTotalSeconds = 0

      this.fetchNextQuestion(true)

    },



    // 按需获取下一题

    async fetchNextQuestion(initial = false) {

      const userInfo = getTokenInfo()

      const userId = userInfo ? userInfo.id : null

      if (!userId) {

        this.$message.error('未登录或用户信息缺失')

        this.isChallengeActive = false

        return

      }



      if (initial) this.loading = true; else this.loadingNext = true

      this.error = null

      try {

        const resp = await getOneUnattemptedQuestion(userId, this.repoId)

        const q = resp?.data?.data ?? resp?.data ?? null

        if (!q) {

          this.error = '暂无可用题目'

          this.isChallengeActive = false

          return

        }

        // 归一化字段

        this.currentQuestion = {

          id: q.id,

          contentCn: q.contentCn || q.contentcn || q.content || '',

          contentEn: q.contentEn || q.contenten || q.content || '',

          optionsStr: q.optionsCn || q.options_cn || q.optionsEn || q.options_en || q.optionsStr || q.options || q.choices || '',

          answer: q.answer || q.correctAnswer || '',

          knowledge: q.knowledge || q.knowledgeName || q.knowledgePoint || '',

          difficulty: q.difficulty != null ? q.difficulty : 0.5,

          analysisCn: q.analysisCn || q.analysiscn || q.analysis || q.judge || '',

          analysisEn: q.analysisEn || q.analysisen || q.analysis || q.judge || '',

          imagePaths: q.imagePaths || q.image_paths || '',

          image_paths: q.image_paths || q.imagePaths || '',

          image: q.image || '',

          optionImages: q.optionImages || q.option_images || ''

        }

        // 重置答题状态

        this.userAnswer = ''

        this.hasAnswered = false

        // 开始计时

        this.startQuestionTimer()

      } catch (e) {

        console.error('获取下一题失败:', e)

        this.error = '获取下一题失败，请稍后重试'

      } finally {

        if (initial) this.loading = false; else this.loadingNext = false

      }

    },



    // 解析选项字符串（兼容多种格式）

    parseOptions(optionsStr) {

      if (!optionsStr) return []

      const s = this.normalizeOptions(String(optionsStr))

      const options = []

      const optionRegex = /\(([A-E])\)\s*([^;]*)/g

      let match

      while ((match = optionRegex.exec(s)) !== null) {

        options.push({ key: match[1], value: match[2].trim() })

      }

      return options

    },

    // 将 A. / B. / C. 等规范为 (A) 形式

    normalizeOptions(raw) {

      if (!raw) return ''

      let s = String(raw).trim()

      s = s

        .replace(/(^|[;\s])A\s*\.?\s*/g, '$1(A) ')

        .replace(/(^|[;\s])B\s*\.?\s*/g, '$1(B) ')

        .replace(/(^|[;\s])C\s*\.?\s*/g, '$1(C) ')

        .replace(/(^|[;\s])D\s*\.?\s*/g, '$1(D) ')

        .replace(/(^|[;\s])E\s*\.?\s*/g, '$1(E) ')

      return s

    },



    // 获取选项完整内容（(A) xxx）

    getFullOptionContent(question, optionKey) {

      if (!optionKey || !question || !question.optionsStr) return optionKey || ''

      const opts = this.parseOptions(question.optionsStr)

      const found = opts.find(o => o.key === String(optionKey).toUpperCase())

      return found ? `${found.key} ${found.value}` : optionKey

    },

    normalizeAnswerValue(value) {

      if (value == null) return ''

      let text = String(value)

      text = text.replace(/<[^>]*>/g, ' ')

      text = text.replace(/&nbsp;/gi, ' ')

      text = text.replace(/（/g, '(').replace(/）/g, ')')

      text = text.replace(/[：:]/g, ':')

      text = text.replace(/^(正确答案|答案|answer)\s*[:：]?/i, '')

      text = text.replace(/\s+/g, ' ')

      return text.trim().toUpperCase()

    },

    extractOptionKey(value) {

      const normalized = this.normalizeAnswerValue(value)

      if (!normalized) return ''

      let match = normalized.match(/^\(?([A-E])\)?$/)

      if (match) return match[1]

      match = normalized.match(/^([A-E])[\.。、:：\s\-]/)

      if (match) return match[1]

      match = normalized.match(/\(([A-E])\)/)

      if (match) return match[1]

      return ''

    },

    getOptionValueByKey(question, optionKey) {

      if (!question || !question.optionsStr || !optionKey) return ''

      const opts = this.parseOptions(question.optionsStr)

      const found = opts.find(item => item.key === String(optionKey).toUpperCase())

      return found ? found.value : ''

    },



    // 解析 AI 判题响应

    parseAiJudge(apiResponse) {

      try {

        const data = apiResponse && (apiResponse.data || apiResponse)

        const jr = data && (data.judgeResult || data)

        if (!jr) return null

        const analysis = jr.ai_analysis || null

        const answerCorrect = analysis && typeof analysis.answer_correct !== 'undefined'

          ? !!analysis.answer_correct

          : null

        return { answerCorrect, analysis }

      } catch (e) {

        return null

      }

    },



    // 持久化当前题作答记录与 AMC 汇总

    async persistChallengeRecord({ isCorrect, aiInfo }) {

      try {

        const user = getTokenInfo && getTokenInfo()

        const userId = user?.id

        if (!userId || !this.currentQuestion) return

        const q = this.currentQuestion

        const now = new Date().toISOString()

        const aiStep = aiInfo?.analysis?.step_analysis || ''

        const aiSug = aiInfo?.analysis?.suggestion || ''

        const baseJudge = q.analysisCn || q.analysisEn || ''

        const judgeText = aiStep ? (aiSug ? `${aiStep}\n建议：${aiSug}` : aiStep) : baseJudge



        // 计算解题用时

        const duration = this.getQuestionDuration()



        // 获取题目中英文内容

        const quesContentCn = q.contentCn || q.contentcn || q.content || ''

        const quesContentEn = q.contentEn || q.contenten || ''



        const record = {

          userId: userId,

          quesId: q.id,

          quescontent_cn: quesContentCn,

          quescontent_en: quesContentEn,

          duration: duration,

          userAnswer: this.getFullOptionContent(q, this.userAnswer),

          answer: q.answer || '',

          judge: judgeText,

          mynote: '',

          isReview: 0,

          knowledge: q.knowledge || '',

          isRight: isCorrect ? 1 : 0,

          repoId: Number(this.repoId) || this.repoId,

          time: now,

          aiAnalysis: aiInfo ? JSON.stringify(aiInfo) : null

        }

        await Promise.allSettled([

          addRecord(record)

        ])

      } catch (e) {

        // 静默失败

      }

    },



    // 在挑战结束时，上报一次 AMC 状态汇总

    async persistChallengeStatus() {

      try {

        if (this.statusSubmitted) return

        const user = getTokenInfo && getTokenInfo()

        const userId = user?.id

        if (!userId) return

        const quesList = this.attemptedIds.join(';')

        const count = this.totalAnswered

        const rightCount = this.consecutiveCount

        const payload = { userId, quesList, count, rightCount, source: '连对挑战', repoId: Number(this.repoId) || this.repoId }

        await userStatusAdd(payload)

        this.statusSubmitted = true

      } catch (e) {

        // 静默失败

      }

    },



    // 答案变化处理

    onAnswerChange() {

      console.log('用户答案:', this.userAnswer)

    },



    // 检查答案是否正确

    isAnswerCorrect() {

      const question = this.currentQuestion || {}

      const userRaw = this.userAnswer

      const correctRaw = question.answer

      const userNormalized = this.normalizeAnswerValue(userRaw)

      const correctNormalized = this.normalizeAnswerValue(correctRaw)

      if (!userNormalized || !correctNormalized) return false

      if (userNormalized === correctNormalized) return true

      const userKey = this.extractOptionKey(userRaw)

      const correctKey = this.extractOptionKey(correctRaw)

      if (userKey && correctKey && userKey === correctKey) return true

      if (userKey) {

        const selectedOptionText = this.normalizeAnswerValue(this.getOptionValueByKey(question, userKey))

        const fullOptionText = this.normalizeAnswerValue(this.getFullOptionContent(question, userKey))

        if (selectedOptionText && selectedOptionText === correctNormalized) return true

        if (fullOptionText && fullOptionText === correctNormalized) return true

      }

      if (correctKey) {

        const correctOptionText = this.normalizeAnswerValue(this.getOptionValueByKey(question, correctKey))

        if (userNormalized === correctOptionText) return true

      }

      return false

    },



    // 获取难度类

    getDifficultyClass(difficulty) {

      const level = this.getDifficultyLevel(difficulty)

      return `difficulty-${level}`

    },



    // 根据数字难度获取难度级别

    getDifficultyLevel(difficulty) {

      if (difficulty <= 0.3) return 'easy'

      if (difficulty <= 0.7) return 'medium'

      return 'hard'

    },



    // 获取难度文本

    getDifficultyText(difficulty) {

      const level = this.getDifficultyLevel(difficulty)

      const textMap = {

        'easy': '简单',

        'medium': '中等',

        'hard': '困难'

      }

      return textMap[level] || '未知'

    },



    // 开始当前题目计时

    startQuestionTimer() {

      this.questionStartTime = Date.now()

      // 清除旧计时器

      if (this.timerInterval) clearInterval(this.timerInterval)

      // 启动新计时器

      this.currentQuestionTime = '00:00'

      this.timerColor = '#67C23A'

      this.timerInterval = setInterval(() => {

        if (this.questionStartTime) {

          const elapsed = Date.now() - this.questionStartTime

          const totalSeconds = Math.floor(elapsed / 1000)



          // 颜色逻辑

          if (totalSeconds < 30) {

            this.timerColor = '#67C23A' // 绿

          } else if (totalSeconds < 60) {

            this.timerColor = '#E6A23C' // 黄

          } else if (totalSeconds < 80) {

            this.timerColor = '#FF7700' // 橙

          } else {

            this.timerColor = '#F56C6C' // 红

          }



          // 超时处理 (90秒)

          if (totalSeconds >= 90 && !this.hasAnswered) {

            this.handleTimeout()

            return

          }



          const mins = Math.floor(totalSeconds / 60)

          const secs = totalSeconds % 60

          this.currentQuestionTime = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`

        }

      }, 1000)

    },



    // 处理超时

    async handleTimeout() {

      if (this.timerInterval) clearInterval(this.timerInterval)

      this.$message.warning('答题超时，挑战结束')

      this.hasAnswered = true

      this.totalAnswered++



      // 自动判错

      this.updateBestRecord()

      try { await this.persistChallengeStatus() } catch (e) {}



      // 记录错误

      try {

        await this.persistChallengeRecord({ isCorrect: false, aiInfo: null })

      } catch (_) {}

      try {

        if (this.currentQuestion && this.currentQuestion.id != null) {

          await this.syncStudyProgress(this.currentQuestion.id, false)

        }

      } catch (_) {}



      // 显示结果

      this.showResult()

    },

    // 获取当前题目解题用时（秒）

    getQuestionDuration() {

      if (!this.questionStartTime) return '0'

      const duration = (Date.now() - this.questionStartTime) / 1000

      return duration.toFixed(2)

    },



    // 格式化题目内容

    formatQuestionContent(content) {

      if (!content) return '暂无题目内容'

      return content.replace(/\n/g, '<br>')

    },



    // 将文本中的 LaTeX 渲染为 KaTeX，兼容 $...$/$$...$$ 以及 \(\)/\[\]

    renderWithMath(text) {

      if (!text) return ''

      try {

        let html = String(text)



        // 兼容双重转义：\\( ... \\) / \\[ ... \\]

        html = html.replace(/\\\\\[([\s\S]+?)\\\\\]/g, (_, expr) => `$$${expr}$$`)

        html = html.replace(/\\\\\(([\s\S]+?)\\\\\)/g, (_, expr) => `$${expr}$`)



        // 兼容常见的 \( ... \) / \[ ... \]

        html = html.replace(/\\\[([\s\S]+?)\\\]/g, (_, expr) => `$$${expr}$$`)

        html = html.replace(/\\\(([\s\S]+?)\\\)/g, (_, expr) => `$${expr}$`)



        // 先处理块级 $$...$$

        html = html.replace(/\$\$([\s\S]+?)\$\$/g, (_, expr) => {

          try {

            return katex.renderToString(expr, { displayMode: true, throwOnError: false })

          } catch (e) {

            return `$$${expr}$$`

          }

        })

        // 再处理行内 $...$

        html = html.replace(/\$([^$\n]+?)\$/g, (_, expr) => {

          try {

            return katex.renderToString(expr, { displayMode: false, throwOnError: false })

          } catch (e) {

            return `$${expr}$`

          }

        })

        // 换行

        return html.replace(/\n/g, '<br>')

      } catch (e) {

        return text

      }

    },



    // 提交答案

    async submitAnswer() {

      if (!this.userAnswer) {

        this.$message.warning('请先选择答案')

        return

      }



      this.submitting = true



      try {

        this.hasAnswered = true

        this.totalAnswered++

        let isCorrect = this.isAnswerCorrect()

        let aiInfo = null



        // 若选择了本地图片，调用 AI 判题

        const file = this.uploadedImageFile

        if (file && this.currentQuestion) {

          try {

            const formData = new FormData()

            formData.append('question', this.getContent(this.currentQuestion))

            formData.append('user_answer', this.getFullOptionContent(this.currentQuestion, this.userAnswer))

            formData.append('correct_answer', this.getFullOptionContent(this.currentQuestion, this.currentQuestion.answer))

            formData.append('explanation', this.getExplanation(this.currentQuestion))

            formData.append('image', file, file.name)



            let loadingService = null

            try {

              loadingService = this.$loading({ lock: true, text: 'AI分析中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.35)' })

              const resp = await judgeSolution(formData)

              const parsed = this.parseAiJudge(resp)

              if (parsed) {

                aiInfo = parsed

                if (typeof parsed.answerCorrect === 'boolean') {

                  isCorrect = parsed.answerCorrect

                }

              }

            } finally {

              if (loadingService) loadingService.close()

            }

          } catch (e) {

            console.warn('AI判题失败，保留本地判定:', e)

          }

        }



        if (isCorrect) {

          this.consecutiveCount++

          this.$message.success(`回答正确！当前连对数：${this.consecutiveCount}`)

        } else {

          this.$message.error('回答错误，挑战结束')

          // 更新最佳记录

          this.updateBestRecord()

          // 汇总一次挑战状态（只在结束时上报）

          try { await this.persistChallengeStatus() } catch (e) {}

          // 答错时自动显示结果弹窗

          setTimeout(() => {

            this.showResult()

          }, 1500)

        }



        // 持久化作答记录与状态汇总

        // 每题记录：仅写入 amcrecord

        await this.persistChallengeRecord({ isCorrect, aiInfo })

        if (this.currentQuestion && this.currentQuestion.id != null) {

          await this.syncStudyProgress(this.currentQuestion.id, isCorrect)

        }

        // 记录已答题 id

        if (this.currentQuestion && this.currentQuestion.id != null) {

          this.attemptedIds.push(this.currentQuestion.id)

        }

      } catch (error) {

        console.error('提交答案失败:', error)

        this.$message.error('提交答案失败，请重试')

      } finally {

        this.submitting = false

      }

    },



    // 下一题

    async nextQuestion() {

      this.questionNumber++

      await this.fetchNextQuestion(false)

    },



    // 更新最佳记录

    updateBestRecord() {

      if (this.consecutiveCount > this.bestRecord) {

        this.bestRecord = this.consecutiveCount

        localStorage.setItem('consecutive_challenge_best_record', this.bestRecord.toString())

        console.log(`新纪录！连对数：${this.bestRecord}`)

      }

    },



    // 显示结果弹窗

    showResult() {

      this.updateBestRecord()

      this.saveChallengeResult()

      this.isChallengeActive = false

      this.showResultDialog = true

    },



    // 关闭结果弹窗

    handleCloseResultDialog() {

      this.showResultDialog = false

    },



    // 重新挑战

    restartChallenge() {

      this.showResultDialog = false

      this.startChallenge()

    },



    // 返回课程首页

    backToCourse() {

      this.showResultDialog = false

      this.showLanding = true

      this.isChallengeActive = false

      this.currentQuestion = null

      this.userAnswer = ''

      this.hasAnswered = false

      this.submitting = false

      this.loading = false

      this.loadingNext = false

      this.error = null

      this.questionStartTime = null

      this.currentQuestionTime = '00:00'

      this.timerColor = '#67C23A'

      if (this.timerInterval) {

        clearInterval(this.timerInterval)

        this.timerInterval = null

      }

    },



    // 结束挑战

    endChallenge() {

      this.$confirm('确定要结束当前挑战吗？', '结束挑战', {

        confirmButtonText: '确定',

        cancelButtonText: '取消',

        type: 'warning'

      }).then(() => {

        this.updateBestRecord()

        this.saveChallengeResult()

        this.isChallengeActive = false

        this.showResultDialog = true

      }).catch(() => {

        this.$message.info('已取消结束挑战')

      })

    },



    // 刷新挑战

    refreshChallenge() {

      this.loadQuestions()

    },



    // 获取挑战状态类

    getChallengeStatusClass() {

      if (this.consecutiveCount >= 10) return 'status-excellent'

      if (this.consecutiveCount >= 5) return 'status-good'

      if (this.consecutiveCount >= 3) return 'status-normal'

      return 'status-start'

    },



    // 获取挑战状态文本

    getChallengeStatusText() {

      if (this.consecutiveCount >= 10) return '挑战大师'

      if (this.consecutiveCount >= 5) return '挑战高手'

      if (this.consecutiveCount >= 3) return '挑战新手'

      return '开始挑战'

    },



    // 获取进度条颜色

    getProgressColor() {

      if (this.consecutiveCount >= 10) return '#67c23a'

      if (this.consecutiveCount >= 5) return '#e6a23c'

      return '#409eff'

    },



    // 获取结果标题

    getResultTitle() {

      if (this.consecutiveCount >= 10) return '挑战大师！'

      if (this.consecutiveCount >= 5) return '挑战高手！'

      if (this.consecutiveCount >= 3) return '挑战新手！'

      return '挑战结束'

    },



    // 获取结果消息

    getResultMessage() {

      if (this.consecutiveCount >= 10) {

        return '恭喜你成为挑战大师！你的连对能力非常出色！'

      } else if (this.consecutiveCount >= 5) {

        return '表现不错！你已经是一个挑战高手了！'

      } else if (this.consecutiveCount >= 3) {

        return '继续加油！你已经有了不错的开始！'

      } else {

        return '不要灰心，多练习就能提高！'

      }

    },



    // 返回上一页

    goBack() {

      const backToCourseCenter = () => {

        const query = {

          ...(this.$route?.query || {})

        }

        this.$router.push({

          path: '/amc-course',

          query

        })

      }



      if (this.isChallengeActive) {

        this.$confirm('当前有进行中的挑战，确定要离开吗？', '离开挑战', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning'

        }).then(() => {

          backToCourseCenter()

        }).catch(() => {

          this.$message.info('已取消离开')

        })

      } else {

        backToCourseCenter()

      }

    },



    // 渲染数学公式

    renderMathFormula(text) {

      return this.renderWithMath(text)

    },



    // 本地选择图片

    handleBeforeUpload() { return false },

    handleFileChange(file, fileList) {

      if (file && file.raw) {

        this.uploadedImageFile = file.raw

        // 为预览生成 URL

        const url = (window.URL || window.webkitURL).createObjectURL(file.raw)

        const showItem = { name: file.name, url }

        this.imageFileList = [showItem]

        try { this.$message.success('已选择图片，将在提交时用于AI判题') } catch (e) {}

      }

    },

    handleRemoveImage() {

      this.uploadedImageFile = null

      this.imageFileList = []

    },



    beforeImageUpload(file) {

      const isImage = file && file.type && file.type.startsWith('image/')

      const isLt5M = file && file.size / 1024 / 1024 < 5

      if (!isImage) {

        this.$message.error('只能上传图片文件!')

        return false

      }

      if (!isLt5M) {

        this.$message.error('图片大小不能超过 5MB!')

        return false

      }

      return true

    },



    handleImageUploadSuccess(response, file) {

      const fileObj = file && (file.raw || file)

      if (!fileObj) return

      this.uploadedImageFile = fileObj

      const previewUrl = (window.URL || window.webkitURL).createObjectURL(fileObj)

      this.uploadedImages.push({

        name: fileObj.name || (file && file.name) || 'image',

        url: previewUrl

      })

      this.imageFileList = [{

        name: fileObj.name || (file && file.name) || 'image',

        url: previewUrl

      }]

      this.$message.success('图片上传成功!')

    },



    handleImageUploadError(error) {

      console.error('图片上传失败:', error)

      this.$message.error('图片上传失败，请重试')

    },



    // 获取题目图片列表

    getQuestionImages(q) {

      if (!q) return []

      const paths = q.imagePaths || q.image_paths || q.image || ''

      if (!paths) return []

      const convertPath = (path) => {
        if (!path) return ''
        const trimmedPath = String(path).trim()
        if (!trimmedPath) return ''
        if (trimmedPath.startsWith('http')) return trimmedPath
        if (trimmedPath.startsWith('/api/file/')) return trimmedPath
        // 使用 MinIO URL 处理
        try { return getMinioUrl(trimmedPath) } catch (_) {}
        return trimmedPath
      }

      try {

        const arr = typeof paths === 'string' ? JSON.parse(paths) : paths

        if (Array.isArray(arr)) {

          return arr.filter(p => p && String(p).trim()).map(p => convertPath(p)).filter(Boolean)

        }

      } catch (e) {

        if (typeof paths === 'string' && paths.trim()) {

          return [convertPath(paths.trim())].filter(Boolean)

        }

      }

      return []

    },

    // 判断题目是否有选项图片
    hasOptionImages(question) {
      if (!question) return false
      const raw = question.optionImages || question.option_images
      if (!raw) return false
      if (Array.isArray(raw)) return raw.some(item => String(item || '').trim())
      if (typeof raw === 'string') return !!raw.trim()
      return false
    },

    // 获取选项文字（用于选项图片场景）
    getOptionText(question) {
      if (!question) return ''
      return question.optionsCn || question.optionsEn || question.options || question.optionsStr || ''
    },

    // 获取指定索引的选项图片
    getOptionImage(question, optionIndex) {
      if (!question) return null
      const raw = question.optionImages || question.option_images
      if (!raw) return null
      let imagePaths = []
      if (Array.isArray(raw)) {
        imagePaths = raw.map(item => String(item || '').trim()).filter(Boolean)
      } else if (typeof raw === 'string') {
        const trimmed = raw.trim()
        if (!trimmed) return null
        try {
          const parsed = JSON.parse(trimmed)
          if (Array.isArray(parsed)) {
            imagePaths = parsed.map(item => String(item || '').trim()).filter(Boolean)
          }
        } catch (e) {
          imagePaths = trimmed.split(/[;,]/).map(item => item.trim()).filter(Boolean)
        }
      }
      return imagePaths[optionIndex] || null
    },

    // 预览图片

    previewImage(url) {

      this.previewImageUrl = url

      this.showImagePreview = true

    },



    // 删除图片

    removeImage(index) {

      this.$confirm('确定要删除这张图片吗？', '删除确认', {

        confirmButtonText: '确定',

        cancelButtonText: '取消',

        type: 'warning'

      }).then(() => {

        this.uploadedImages.splice(index, 1)

        this.$message.success('图片已删除')

      }).catch(() => {

        this.$message.info('已取消删除')

      })

    }

  }

}

</script>



<style scoped>

.consecutive-challenge-container {

  min-height: 100vh;

  background-color: #f5f7fa;

  padding: 0;

  margin: 0;

  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

}



/* 顶部导航栏 */

.challenge-header {

  background: rgba(255, 255, 255, 0.95);

  backdrop-filter: blur(10px);

  padding: 20px 30px;

  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.12);

  position: sticky;

  top: 0;

  z-index: 100;

  display: flex;

  justify-content: space-between;

  align-items: center;

}



.header-left {

  display: flex;

  align-items: center;

  gap: 15px;

}



.header-right {

  display: flex;

  align-items: center;

  flex-wrap: wrap;

}



.timer-display {

  display: flex;

  align-items: center;

  gap: 6px;

  font-size: 14px;

}



.back-btn {

  font-size: 20px;

  color: #666;

  cursor: pointer;

  padding: 5px;

  border-radius: 50%;

  transition: background-color 0.3s;

}



.back-btn:hover {

  background-color: #f5f5f5;

}



.page-title {

  margin: 0;

  font-size: 18px;

  font-weight: 600;

  color: #333;

}



/* 统计信息 */

.stats-section {

  display: grid;

  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));

  gap: 15px;

  padding: 20px 30px;

  background: transparent;

  color: #333;

}



.stat-card {

  background: rgba(255, 255, 255, 0.95);

  border-radius: 14px;

  padding: 18px 14px;

  text-align: center;

  box-shadow: 0 6px 18px rgba(31, 38, 135, 0.08);

  border: 1px solid rgba(255, 255, 255, 0.5);

}



.stat-number {

  font-size: 28px;

  font-weight: bold;

  margin-bottom: 8px;

}



.stat-label {

  font-size: 14px;

  opacity: 0.85;

}



/* 加载和错误状态 */

.loading-container, .error-container, .empty-container {

  display: flex;

  justify-content: center;

  align-items: center;

  min-height: 400px;

}



.error-content, .empty-content {

  text-align: center;

  padding: 40px;

}



.error-icon, .empty-icon {

  font-size: 48px;

  color: #f56c6c;

  margin-bottom: 20px;

}



.empty-icon {

  color: #c0c4cc;

}



.error-message, .empty-message {

  font-size: 16px;

  color: #666;

  margin-bottom: 20px;

}



/* 挑战内容 */

.challenge-content {

  padding: 20px 30px;

}



/* 题目卡片 */

.question-card {

  background: white;

  border-radius: 20px;

  padding: 35px;

  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.12);

  margin-bottom: 24px;

}



.question-header {

  display: flex;

  justify-content: space-between;

  align-items: center;

  margin-bottom: 25px;

  padding-bottom: 15px;

  border-bottom: 2px solid #f0f0f0;

}



.question-title {

  display: flex;

  flex-direction: column;

  gap: 5px;

}



.question-number {

  font-size: 20px;

  font-weight: 600;

  color: #333;

}



.challenge-status {

  font-size: 14px;

  padding: 4px 12px;

  border-radius: 20px;

  font-weight: 500;

}



.status-start {

  background: #e6f7ff;

  color: #1890ff;

}



.status-normal {

  background: #f6ffed;

  color: #52c41a;

}



.status-good {

  background: #fff7e6;

  color: #fa8c16;

}



.status-excellent {

  background: #f6ffed;

  color: #52c41a;

  animation: pulse 2s infinite;

}



@keyframes pulse {

  0% { transform: scale(1); }

  50% { transform: scale(1.05); }

  100% { transform: scale(1); }

}



.question-meta {

  display: flex;

  gap: 10px;

  align-items: center;

}



.question-difficulty {

  font-size: 12px;

  padding: 6px 12px;

  border-radius: 20px;

  font-weight: 500;

}



.difficulty-easy {

  background: #f6ffed;

  color: #52c41a;

}



.difficulty-medium {

  background: #fff7e6;

  color: #fa8c16;

}



.difficulty-hard {

  background: #fff2f0;

  color: #ff4d4f;

}



.question-knowledge {

  font-size: 12px;

  padding: 6px 12px;

  border-radius: 20px;

  background: #f0f0f0;

  color: #666;

}



.question-content {

  margin-bottom: 25px;

  font-size: 16px;

  line-height: 1.8;

  word-break: break-word;

  color: #333;

}



.question-images {

  margin: 10px 0 20px;

  display: flex;

  flex-wrap: wrap;

  gap: 10px;

}



.question-img {

  max-width: 480px;

  max-height: 360px;

  object-fit: contain;

  border-radius: 6px;

  border: 1px solid #e4e7ed;

  cursor: pointer;

  transition: transform 0.2s;

}



.question-img:hover {

  transform: scale(1.02);

  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);

}



/* 图片上传区域 */

.image-upload-section {

  margin-bottom: 25px;

  padding: 20px;

  background: #f8f9fa;

  border-radius: 8px;

  border: 1px dashed #d9d9d9;

}



.upload-button-container {

  display: flex;

  align-items: center;

  gap: 15px;

  margin-bottom: 15px;

}



.image-uploader {

  display: inline-block;

}



.upload-tip {

  font-size: 12px;

  color: #999;

}



.uploaded-images {

  margin-top: 15px;

}



.image-preview-title {

  font-size: 14px;

  font-weight: 500;

  color: #333;

  margin-bottom: 10px;

}



.image-list {

  display: flex;

  flex-wrap: wrap;

  gap: 15px;

}



.image-item {

  position: relative;

  width: 120px;

  height: 120px;

  border-radius: 8px;

  overflow: hidden;

  border: 1px solid #e0e0e0;

  background: #fff;

}



.image-item img {

  width: 100%;

  height: 100%;

  object-fit: cover;

}



.image-actions {

  position: absolute;

  top: 0;

  left: 0;

  right: 0;

  bottom: 0;

  background: rgba(0, 0, 0, 0.5);

  display: flex;

  justify-content: center;

  align-items: center;

  gap: 10px;

  opacity: 0;

  transition: opacity 0.3s;

}



.image-item:hover .image-actions {

  opacity: 1;

}



.image-actions .el-button {

  color: #fff;

  background: rgba(255, 255, 255, 0.2);

  border: 1px solid rgba(255, 255, 255, 0.3);

}



.image-actions .el-button:hover {

  background: rgba(255, 255, 255, 0.3);

}



/* 图片预览弹窗 */

.image-preview-dialog {

  text-align: center;

}



.preview-image {

  max-width: 100%;

  max-height: 80vh;

  border-radius: 8px;

  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);

}



.question-options {

  margin-bottom: 25px;

}



.option-item {

  display: block;

  margin-bottom: 12px;

  font-size: 15px;

  padding: 8px 0;

}



.question-answer-input {

  margin-bottom: 25px;

}



.answer-tip {

  font-size: 12px;

  color: #999;

  margin-left: 10px;

}



.answer-status {

  margin-bottom: 20px;

  padding: 15px;

  border-radius: 8px;

  display: flex;

  align-items: center;

  gap: 10px;

  font-weight: 500;

}



.correct-answer {

  background: #f6ffed;

  color: #52c41a;

  border: 1px solid #b7eb8f;

}



.incorrect-answer {

  background: #fff2f0;

  color: #ff4d4f;

  border: 1px solid #ffccc7;

}



.analysis-section {

  background: #f8f9fa;

  padding: 20px;

  border-radius: 8px;

  margin-bottom: 25px;

}



.analysis-title {

  font-weight: 600;

  color: #333;

  margin-bottom: 15px;

  font-size: 16px;

}



.analysis-content {

  font-size: 14px;

  line-height: 1.6;

  color: #666;

}



.action-buttons {

  display: flex;

  justify-content: center;

  gap: 20px;

}



/* 进度条区域 */

.progress-section {

  background: #fff;

  border-radius: 12px;

  padding: 20px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

}



.progress-info {

  display: flex;

  justify-content: space-between;

  align-items: center;

  margin-bottom: 10px;

  font-weight: 500;

  color: #333;

}



/* 结果弹窗 */

.result-content {

  text-align: center;

  padding: 20px;

}



.result-icon {

  font-size: 64px;

  color: #ff6b6b;

  margin-bottom: 20px;

}



.result-title {

  font-size: 24px;

  font-weight: 600;

  color: #333;

  margin-bottom: 20px;

}



.result-stats {

  margin-bottom: 20px;

}



.result-stat-item {

  display: flex;

  justify-content: space-between;

  align-items: center;

  padding: 10px 0;

  border-bottom: 1px solid #f0f0f0;

}



.stat-label {

  font-weight: 500;

  color: #666;

}



.stat-value {

  font-weight: 600;

  color: #333;

  font-size: 18px;

}



.stat-value.new-record {

  color: #ff6b6b;

  font-size: 24px;

}



.result-message {

  font-size: 16px;

  color: #666;

  line-height: 1.6;

  margin-top: 20px;

}



/* 过渡界面 */

.landing-container {

  display: flex;

  flex-direction: column;

  align-items: center;

  padding: 40px 24px 30px;

  max-width: 480px;

  margin: 0 auto;

}



.landing-hero {

  text-align: center;

  margin-bottom: 28px;

}



.landing-icon {

  font-size: 56px;

  margin-bottom: 10px;

}



.landing-title {

  font-size: 26px;

  font-weight: 700;

  color: #222;

  margin: 0 0 10px;

}



.landing-desc {

  font-size: 14px;

  color: #888;

  line-height: 1.7;

  margin: 0;

}



.landing-rules {

  display: flex;

  gap: 12px;

  flex-wrap: wrap;

  justify-content: center;

  margin-bottom: 24px;

}



.rule-tag {

  display: inline-flex;

  align-items: center;

  gap: 5px;

  padding: 6px 16px;

  border-radius: 20px;

  font-size: 13px;

  font-weight: 500;

  background: #e6f7ff;

  color: #1890ff;

}



.rule-tag-danger {

  background: #fff2f0;

  color: #ff4d4f;

}



.rule-tag-warn {

  background: #fff7e6;

  color: #fa8c16;

}



.landing-best {

  background: linear-gradient(135deg, #fffbe6 0%, #fff1b8 100%);

  padding: 12px 28px;

  border-radius: 24px;

  font-size: 15px;

  color: #d48806;

  margin-bottom: 32px;

  text-align: center;

}



.landing-best i {

  margin-right: 4px;

}



.landing-start {

  width: 100%;

  margin-bottom: 36px;

}



.start-challenge-btn {

  width: 100%;

  padding: 16px 0;

  font-size: 18px;

  font-weight: 700;

  color: #fff;

  border: none;

  border-radius: 28px;

  cursor: pointer;

  background: linear-gradient(135deg, #ff9a3e 0%, #ff4e50 100%);

  box-shadow: 0 8px 24px rgba(255, 78, 80, 0.35);

  transition: transform 0.2s, box-shadow 0.2s;

  letter-spacing: 2px;

}



.start-challenge-btn:hover {

  transform: translateY(-2px);

  box-shadow: 0 12px 28px rgba(255, 78, 80, 0.45);

}



.start-challenge-btn:active {

  transform: translateY(0);

}



.leaderboard-btn {

  width: 100%;

  padding: 12px 0;

  font-size: 15px;

  font-weight: 600;

  color: #fff;

  border: none;

  border-radius: 24px;

  cursor: pointer;

  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

  box-shadow: 0 6px 18px rgba(102, 126, 234, 0.3);

  transition: transform 0.2s, box-shadow 0.2s;

  letter-spacing: 1px;

}



.leaderboard-btn:hover {

  transform: translateY(-2px);

  box-shadow: 0 10px 24px rgba(102, 126, 234, 0.4);

}



.leaderboard-btn:active {

  transform: translateY(0);

}



.leaderboard-btn i {

  margin-right: 6px;

}



.landing-stats-card {

  width: 100%;

  background: #fff;

  border-radius: 16px;

  padding: 20px 18px;

  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);

}



.landing-record-columns {

  display: grid;

  grid-template-columns: repeat(2, minmax(0, 1fr));

  gap: 16px;

}



.landing-record-column {

  min-width: 0;

}



.landing-record-title {

  text-align: center;

  font-weight: 600;

  color: #333;

  padding-bottom: 12px;

  margin-bottom: 12px;

  border-bottom: 2px solid #f0f0f0;

}



.landing-record-list {

  display: flex;

  flex-direction: column;

  gap: 10px;

  max-height: 220px;

  overflow-y: auto;

}



.landing-record-item {

  padding: 10px 12px;

  border: 1px solid #f2f2f2;

  border-radius: 12px;

  background: #fafafa;

}



.landing-record-main {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 10px;

  margin-bottom: 6px;

}



.landing-record-count {

  color: #333;

  font-size: 14px;

  font-weight: 600;

}



.landing-record-time {

  color: #ff7f50;

  font-size: 14px;

  font-weight: 700;

}



.landing-record-date {

  color: #999;

  font-size: 12px;

}



.landing-record-empty {

  height: 120px;

  display: flex;

  align-items: center;

  justify-content: center;

  color: #999;

  font-size: 14px;

  background: #fafafa;

  border-radius: 12px;

}



.leaderboard-range-tabs {

  display: flex;

  justify-content: center;

  margin-bottom: 16px;

}



/* 响应式设计 */

@media (max-width: 768px) {

  .landing-record-columns {

    grid-template-columns: 1fr;

  }



  .challenge-header {

    padding: 10px 15px;

    flex-direction: column;

    gap: 10px;

  }



  .header-left {

    width: 100%;

    justify-content: space-between;

  }



  .header-right {

    width: 100%;

    justify-content: center;

  }



  .stats-section {

    gap: 12px;

    padding: 12px 15px;

    grid-template-columns: repeat(2, minmax(0, 1fr));

  }



  .question-card {

    padding: 20px;

  }



  .question-header {

    flex-direction: column;

    align-items: flex-start;

    gap: 15px;

  }



  .question-meta {

    width: 100%;

    justify-content: flex-start;

  }



  .action-buttons {

    flex-direction: column;

    gap: 15px;

  }



  .challenge-content {

    padding: 15px;

  }



  .image-upload-section {

    padding: 15px;

  }



  .upload-button-container {

    flex-direction: column;

    align-items: flex-start;

    gap: 10px;

  }



  .image-list {

    gap: 10px;

  }



  .image-item {

    width: 100px;

    height: 100px;

  }

}



@media (max-width: 480px) {

  .stat-number {

    font-size: 24px;

  }



  .question-content {

    font-size: 14px;

  }



  .option-item {

    font-size: 14px;

  }

}

</style>

